export default __webpack_public_path__ + "static/media/banner-img-bkp-2.e7878022.jpg";